import { useEffect, useRef } from "react"
import { Button } from "components/shared"
import { Formik, Form as FormikForm } from "formik"
import Lottie from "lottie-react"
import successAnimation from "assets/animations/success.json"
import classNames from "classnames"

const Form = ({
  initialValues,
  validationSchema,
  onSubmit,
  submitText = "Submit",
  submittingText = "Submitting",
  formComplete,
  successMessage,
  className,
  children,
}) => {
  const formCompleteRef = useRef(null)

  useEffect(() => {
    if (formComplete) {
      setTimeout(() => {
        formCompleteRef.current.scrollIntoView({ behavior: "smooth", block: "center" })
        // const element = document.getElementById("completed-form")
        // element.scrollIntoView({ behavior: "smooth", block: "center" })
      }, 250)
    }
  }, [formComplete])

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
      {({ isSubmitting, status, errors, dirty }) => (
        <FormikForm
          className={classNames(
            "flex flex-col items-stretch space-y-4 relative",
            formComplete && "max-h-[500px] overflow-hidden",
            className
          )}
        >
          <div className="flex flex-col space-y-8">{children}</div>
          <div className="flex-1 text-red-500 min-h-[24px] !mt-5">{status}</div>
          <Button
            type="submit"
            animate
            animateOnShow={false}
            className={classNames(
              "flex-1 w-full disabled:opacity-90",
              dirty && Object.keys(errors).length === 0 ? "opacity-100" : "opacity-90"
            )}
            disabled={isSubmitting}
          >
            {isSubmitting ? `${submittingText}...` : submitText}
          </Button>

          {formComplete && (
            <div
              ref={formCompleteRef}
              id="completed-form"
              className="absolute w-full h-full bg-white/95 flex items-center justify-center flex-col !-mt-0 space-y-4 px-2 z-20"
            >
              <Lottie animationData={successAnimation} loop={false} className="w-72 h-72" />
              <div className="text-2xl font-semibold">Thank You!</div>
              <p className="text-center">{successMessage}</p>
            </div>
          )}
        </FormikForm>
      )}
    </Formik>
  )
}

export default Form
